import { useConfigPermission } from "context/useConfigPermission";
import { useProductConfiguration } from "context/useProductConfiguration";
import { Link } from "react-router-dom";
import { isBulletPointsConfigEmpty, isExtraLinkConfigEmpty, isInfoTextConfigEmpty, isLogoConfigEmpty, isSearchWordsConfigEmpty } from "utility/ProductUtility";
import { UrlPath } from "utility/routes";

type EmptyConfigNagBannerProps = {
    id:string
}

const EmptyConfigNagBanner = ({id}:EmptyConfigNagBannerProps) =>{

    const { canConfig } = useConfigPermission();
    const { productConfigurationsByCompany } = useProductConfiguration();


    if (id === undefined || id === null)
        return <></>;

    const config = productConfigurationsByCompany[id]

    if (!canConfig(id) || !config)
        return null;


    if (isSearchWordsConfigEmpty(config.searchWords) || isLogoConfigEmpty(config.logo) || isBulletPointsConfigEmpty(config.bulletPoints) || isInfoTextConfigEmpty(config.infoText) || isExtraLinkConfigEmpty(config.extraLinks)){
        return <div className="cc-bg-theme-orange m-1 fw-medium rounded-1">
    <Link to={`${UrlPath.Account.Company}/${id}`} className="text-white px-3 py-2 d-block cc-underline-none">
        <i className="bi bi-exclamation-triangle-fill float-end ms-2"></i>
      <p className="m-0 text-lg-center"><span>Kjøpte produkter mangler <u className="cc-underline-50 d-inline-block">utfylt informasjon</u>!</span></p>
    </Link>
</div>
    }
    else{
        return null;
    }
        


}


export default EmptyConfigNagBanner;